import moment from '../../node_modules/moment';

const saveFormat = 'MMMM Do, YYYY, h:mm:ss a';
const CMS = 'https://www.comiccomplex.x10.mx/';

export default {
  saveTime: (t, i) => moment(t, 'YYYYMMDD HHmm').add(i, 'seconds').format(saveFormat),
  showTime: t => moment(t, saveFormat).format('MMMM Do, YYYY, h:mm a'),
  timeCompare: (t1, t2) => (moment(t1, saveFormat) - moment(t2, saveFormat)),
  comic: comic => (comic ? `${CMS}${comic.image}` : `${CMS}error.jpg`),
  popup: (popups, which) => popups.filter(pop => pop.title === which)[0].images.map(i => `${CMS}${i.path}`),
};



// WEBPACK FOOTER //
// ./src/helpers/H.js